/* @flow */
import type { QuickActionType } from 'entities/QuickActions';
import type { Action } from 'action';
import { Map } from 'immutable';

export type StoreQuickActions = {
  actions?: ?QuickActionType[],
}

export type State = Map<number, StoreQuickActions>;
export const initialState: State = new Map();

// typecheck: ignore statement
export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'quickActions/LOAD_QUICK_ACTIONS_SUCCESS':
      return state.set(action.groupId, { actions: action.quickActions });
    default:
      return state;
  }
}

export type loadQuickActionsAction = {
  type: 'quickActions/LOAD_QUICK_ACTIONS',
  groupId: number,
};

export function loadQuickActions(groupId: number): loadQuickActionsAction {
  return {
    type: 'quickActions/LOAD_QUICK_ACTIONS',
    groupId,
  };
}

export type loadQuickActionsSuccessAction = {
  type: 'quickActions/LOAD_QUICK_ACTIONS_SUCCESS',
  groupId: number,
  quickActions: QuickActionType[],
};

export function loadQuickActionsSuccess(groupId: number, quickActions: QuickActionType[]): loadQuickActionsSuccessAction {
  return {
    type: 'quickActions/LOAD_QUICK_ACTIONS_SUCCESS',
    groupId,
    quickActions,
  };
}

export type QuickActionActions = loadQuickActionsAction | loadQuickActionsSuccessAction;



// WEBPACK FOOTER //
// ./src/reducers/quickActions.js